import { useQuery } from '@tanstack/react-query';
import type { SyncLogIdentifier } from '../types';
import { useSyncApi } from './use-sync-api';

export const useSyncErrors = (identifier: SyncLogIdentifier) => {
  const { syncApi } = useSyncApi();

  return useQuery({
    queryKey: ['sync-status', identifier, 'errors'],
    queryFn: () => syncApi.logs().for(identifier).errors(),
  });
};
